import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import * as S from './LFHeader.styled';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { selectToken } from 'redux/global';
import { useHistory } from 'react-router-dom';
import Menu from '@mui/icons-material/Menu';
import { moveSideBar } from 'pages/Navigation/utils';
import { mobileRes2 } from 'pages/styles';
import { selectOrganizationData, setOrganizationData } from 'pages/redux';
import Modal from '../Modal/Modal';
import LoggedInModal from './modals/LoggedInModal';
import { usePath } from 'pages/hooks';
import { getMarketingSiteUrl } from 'utils';

/** One generated mark — same file as splash, favicon, and PWA icons. */
export const APP_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo.png`;

export const TrippleLogo = ({
  isHome,
  showText,
  onDark,
}: { isHome?: boolean; showText?: boolean; onDark?: boolean }) => (
  <S.LogoCont>
    <S.LogoMark isHome={!!isHome} onDark={!!onDark}>
      <S.LogoImg src={APP_LOGO_SRC} alt="Tripple" isHome={!!isHome} onDark={!!onDark} />
    </S.LogoMark>
    {showText && (
      <S.LogoBrandText isHome={!!isHome} onDark={!!onDark}>Tripple</S.LogoBrandText>
    )}
  </S.LogoCont>
);

const LFHeader = ({ marketingChrome = false }: { marketingChrome?: boolean }) => {
  const [isShowLogOut, setIsShowLogOut] = useState<boolean>(false);
  const token = useAppSelector(selectToken);
  const organizationData = useAppSelector(selectOrganizationData);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { isHomePath } = usePath();
  const isHomeChrome = isHomePath || marketingChrome;
  // Public auth/marketing screens keep Sign in + Register even with a stale token.
  const showAuthButtons = !token || isHomePath || marketingChrome;

  const header = (
    <>
      {
        isShowLogOut && (
          <Modal
            component={(
              <LoggedInModal
                extraFunction={() => {
                  dispatch(setOrganizationData(null));
                  history.push('/');
                }}
                onExit={() => {
                  setIsShowLogOut(false);
                }}
              />
            )}
            exitOnBgClick={() => setIsShowLogOut(false)}
          />
        )
      }
      <S.Container isHome={isHomeChrome} $overlayAuth={marketingChrome}>
        <S.Menu>
          <S.NamePart>
            {!isHomeChrome && (
              <S.MenuIcon onClick={() => moveSideBar()}>
                <Menu fontSize="medium" />
              </S.MenuIcon>
            )}
            <S.OrganizationName
              isHome={isHomeChrome}
              onClick={() => {
                if (!token || marketingChrome) {
                  window.open(getMarketingSiteUrl('/'), '_blank');
                } else {
                  if (window.innerWidth <= Number(mobileRes2.replace('px', ''))) {
                    moveSideBar();
                    return;
                  }
                  moveSideBar(true);
                  setIsShowLogOut(true);
                }
              }}
            >
              {organizationData?.name && !marketingChrome ? (
                <S.OrganizationNameInner>
                  <S.OrganizationNameText isHome={isHomeChrome}>{organizationData.name}</S.OrganizationNameText>
                  {organizationData?.branch && (
                    <S.BranchBadge isHome={isHomeChrome}>{organizationData.branch}</S.BranchBadge>
                  )}
                </S.OrganizationNameInner>
              ) : (
                <TrippleLogo isHome={isHomeChrome} showText />
              )}
            </S.OrganizationName>
          </S.NamePart>

          {organizationData?.name && !marketingChrome && (
            <S.PoweredBy isHome={isHomeChrome}>
              <S.PoweredByLabel isHome={isHomeChrome}>powered by</S.PoweredByLabel>
              <TrippleLogo isHome={isHomeChrome} showText />
            </S.PoweredBy>
          )}

          {showAuthButtons && (
            <S.SignCont>
              <S.SignInBtn onClick={() => history.push('/signin')} isHome={isHomeChrome}>
                Sign in
              </S.SignInBtn>
              <S.RegisterBtn onClick={() => history.push('/signup')} isHome={isHomeChrome}>
                Register
              </S.RegisterBtn>
            </S.SignCont>
          )}
        </S.Menu>
      </S.Container>
    </>
  );

  if (marketingChrome) {
    return createPortal(header, document.body);
  }
  return header;
};

export default LFHeader;
